import { useState, useRef } from 'react';

const projects = [
  {
    before: 'https://readdy.ai/api/search-image?query=outdated%20worn%20kitchen%20with%20old%20cabinets%20and%20appliances%20before%20renovation%20showing%20dated%20design%20and%20wear%2C%20simple%20neutral%20background%20highlighting%20the%20need%20for%20improvement%20and%20modernization&width=600&height=800&seq=before-kitchen-001&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20renovated%20kitchen%20with%20new%20white%20cabinets%20stainless%20appliances%20and%20granite%20countertops%20after%20remodeling%2C%20simple%20neutral%20background%20showcasing%20the%20transformation%20and%20quality%20craftsmanship&width=600&height=800&seq=after-kitchen-001&orientation=portrait',
    title: 'Kitchen Remodel',
    category: 'Home Remodeling'
  },
  {
    before: 'https://readdy.ai/api/search-image?query=old%20damaged%20bathroom%20with%20worn%20fixtures%20and%20outdated%20tile%20before%20renovation%20showing%20age%20and%20deterioration%2C%20simple%20neutral%20background%20emphasizing%20the%20need%20for%20updates%20and%20repairs&width=600&height=700&seq=before-bathroom-001&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=stunning%20modern%20bathroom%20with%20new%20fixtures%20elegant%20tile%20and%20contemporary%20design%20after%20renovation%2C%20simple%20neutral%20background%20highlighting%20the%20beautiful%20transformation%20and%20attention%20to%20detail&width=600&height=700&seq=after-bathroom-001&orientation=portrait',
    title: 'Bathroom Renovation',
    category: 'Plumbing & Remodeling'
  },
  {
    before: 'https://readdy.ai/api/search-image?query=overgrown%20neglected%20backyard%20with%20dead%20grass%20and%20weeds%20before%20landscaping%20showing%20lack%20of%20maintenance%2C%20simple%20neutral%20background%20demonstrating%20the%20starting%20condition%20and%20potential%20for%20improvement&width=600&height=750&seq=before-landscape-001&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=beautiful%20manicured%20backyard%20with%20lush%20green%20lawn%20flowers%20and%20professional%20landscaping%20after%20transformation%2C%20simple%20neutral%20background%20showcasing%20the%20dramatic%20improvement%20and%20expert%20lawn%20care%20results&width=600&height=750&seq=after-landscape-001&orientation=portrait',
    title: 'Backyard Transformation',
    category: 'Landscaping'
  },
  {
    before: 'https://readdy.ai/api/search-image?query=old%20damaged%20roof%20with%20missing%20shingles%20and%20visible%20wear%20before%20repair%20showing%20deterioration%20and%20weather%20damage%2C%20simple%20neutral%20background%20highlighting%20the%20urgent%20need%20for%20professional%20roofing%20work&width=600&height=700&seq=before-roof-001&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=brand%20new%20roof%20with%20fresh%20shingles%20perfect%20installation%20and%20clean%20appearance%20after%20professional%20repair%2C%20simple%20neutral%20background%20demonstrating%20the%20quality%20workmanship%20and%20complete%20transformation&width=600&height=700&seq=after-roof-001&orientation=portrait',
    title: 'Roof Replacement',
    category: 'Roofing'
  },
  {
    before: 'https://readdy.ai/api/search-image?query=dark%20outdated%20basement%20with%20poor%20lighting%20and%20unfinished%20walls%20before%20renovation%20showing%20wasted%20space%2C%20simple%20neutral%20background%20emphasizing%20the%20untapped%20potential%20and%20need%20for%20improvement&width=600&height=800&seq=before-basement-001&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=bright%20modern%20finished%20basement%20with%20new%20flooring%20lighting%20and%20living%20space%20after%20remodeling%2C%20simple%20neutral%20background%20showcasing%20the%20transformation%20into%20a%20beautiful%20functional%20area&width=600&height=800&seq=after-basement-001&orientation=portrait',
    title: 'Basement Finishing',
    category: 'Home Remodeling'
  },
  {
    before: 'https://readdy.ai/api/search-image?query=dirty%20stained%20exterior%20siding%20and%20driveway%20before%20pressure%20washing%20showing%20years%20of%20grime%20and%20buildup%2C%20simple%20neutral%20background%20demonstrating%20the%20need%20for%20professional%20cleaning%20services&width=600&height=750&seq=before-pressure-001&orientation=portrait',
    after: 'https://readdy.ai/api/search-image?query=sparkling%20clean%20exterior%20siding%20and%20driveway%20after%20professional%20pressure%20washing%20looking%20like%20new%2C%20simple%20neutral%20background%20highlighting%20the%20dramatic%20difference%20and%20restoration%20of%20original%20appearance&width=600&height=750&seq=after-pressure-001&orientation=portrait',
    title: 'Exterior Cleaning',
    category: 'Pressure Washing'
  }
];

function ProjectCard({ project }: { project: typeof projects[0] }) {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex-shrink-0 w-full">
      <div className="relative h-64 sm:h-72">
        <div className="absolute inset-0 flex">
          <div className="w-1/2 relative">
            <img src={project.before} alt={`${project.title} before`} className="w-full h-full object-cover object-top" />
            <div className="absolute top-3 left-3 bg-black/70 text-white px-2.5 py-1 rounded text-xs font-semibold">BEFORE</div>
          </div>
          <div className="w-1/2 relative">
            <img src={project.after} alt={`${project.title} after`} className="w-full h-full object-cover object-top" />
            <div className="absolute top-3 right-3 bg-[#1e40af] text-white px-2.5 py-1 rounded text-xs font-semibold">AFTER</div>
          </div>
        </div>
        <div className="absolute inset-y-0 left-1/2 w-0.5 bg-white z-10"></div>
      </div>
      <div className="p-4 bg-white">
        <h3 className="text-base font-bold text-[#2C2C2C]">{project.title}</h3>
        <p className="text-sm text-[#6B6B6B] mt-1">{project.category}</p>
      </div>
    </div>
  );
}

export default function Gallery() {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef<number | null>(null);

  const prev = () => setCurrent(c => (c === 0 ? projects.length - 1 : c - 1));
  const next = () => setCurrent(c => (c === projects.length - 1 ? 0 : c + 1));

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) diff > 0 ? next() : prev();
    touchStartX.current = null;
  };

  return (
    <section id="gallery" className="py-20 md:py-32 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-24">
          <p className="text-[#1e40af] text-xs font-bold uppercase tracking-widest mb-4">OUR WORK</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-4">Transformations That Speak</h2>
          <p className="text-base sm:text-lg text-[#6B6B6B] max-w-2xl mx-auto">
            See the quality of our work through real projects we've completed for homeowners just like you.
          </p>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </div>

        {/* Mobile Slider */}
        <div className="md:hidden">
          <div
            className="overflow-hidden rounded-xl"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <div
              className="flex transition-transform duration-300 ease-in-out"
              style={{ transform: `translateX(-${current * 100}%)` }}
            >
              {projects.map((project, index) => (
                <div key={index} className="w-full flex-shrink-0 px-0">
                  <ProjectCard project={project} />
                </div>
              ))}
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-between mt-5 px-1">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-200 bg-white shadow-sm hover:bg-gray-50 cursor-pointer"
              aria-label="Previous"
            >
              <i className="ri-arrow-left-s-line text-xl text-gray-600"></i>
            </button>

            {/* Dots */}
            <div className="flex gap-2">
              {projects.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${i === current ? 'bg-[#1e40af] w-5' : 'bg-gray-300'}`}
                  aria-label={`Go to slide ${i + 1}`}
                />
              ))}
            </div>

            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-200 bg-white shadow-sm hover:bg-gray-50 cursor-pointer"
              aria-label="Next"
            >
              <i className="ri-arrow-right-s-line text-xl text-gray-600"></i>
            </button>
          </div>

          <p className="text-center text-sm text-gray-400 mt-3">{current + 1} / {projects.length}</p>
        </div>
      </div>
    </section>
  );
}
